import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.less', '../../warning-popup/warning-popup.component.less', '../../shared/common.less']
})
export class AuthenticationComponent {
  @Input() password: string;
  @Input() validatedPassword = true;
  @Input() validatedSMS = true;
  @Input() phoneNumber: string;
  @Input() phoneChangeable: boolean;
  @Input() welcomeText: string;
  @Input() retries: number;
  @Input() noMoreSMS = false;
  @Input() isValidationCodeError = false;
  @Input() isWrongPhoneError = false;
  @Input() smsSent = false;

  @Output() sendSmsFirstEvent = new EventEmitter();
  @Output() sendSMSEvent = new EventEmitter<boolean>();
  @Output() sendPasswordEvent = new EventEmitter<string>();
  @Output() sendPhoneEvent = new EventEmitter<string>();
  @Output() sendCodeEvent = new EventEmitter<string>();

  shouldCalculateError = false;
  shouldChangePhone = false;

  resendSMS() {
    this.sendSMSEvent.emit(true);
  }

  sendSms() {
    this.sendSmsFirstEvent.emit();
    this.smsSent = true;
  }

  sendPassKey() {
    this.shouldCalculateError = true;
    const password = (document.getElementById('pass-txt') as HTMLInputElement).value;
    this.sendPasswordEvent.emit(password.trim());
  }

  sendPhoneNumber() {
    const password = (document.getElementById('phone-txt') as HTMLInputElement).value;
    this.sendPhoneEvent.emit(password.trim());
    this.shouldChangePhone = false;
  }

  codeInput($event) {
    const alphanum = /^([0-9]|[a-z])+([0-9a-z]+)$/i;
    if ($event.key != null && !$event.key.match(alphanum)) {
      if ($event.target.id.localeCompare('letter-6') !== 0) {
        // setTimeout(function () {
        //   document.getElementById($event.srcElement.nextElementSibling.id).focus();
        // }, 0)
      }
    }
    if ($event.keyCode === 8) {
      if ($event.target.id.localeCompare('letter-1') !== 0) {
        setTimeout(() => {
          document.getElementById($event.srcElement.previousElementSibling.id).focus();
        }, 200);
      }
    }
    const scoppedThis = this;
    setTimeout(() => {
      scoppedThis.validate();
    }, 200);
  }

  resetPhoneError() { this.isWrongPhoneError = false; }

  getPhoneNumberPlaceholder() { return this.phoneNumber != null ? this.phoneNumber : '33123456789'; }

  validate() {
    const letter1 = (document.getElementById('letter-1') as HTMLInputElement).value;
    const letter2 = (document.getElementById('letter-2') as HTMLInputElement).value;
    const letter3 = (document.getElementById('letter-3') as HTMLInputElement).value;
    const letter4 = (document.getElementById('letter-4') as HTMLInputElement).value;
    const letter5 = (document.getElementById('letter-5') as HTMLInputElement).value;
    const letter6 = (document.getElementById('letter-6') as HTMLInputElement).value;
    const confirmationCode = letter1 + letter2 + letter3 + letter4 + letter5 + letter6;
    if (confirmationCode.length === 6){
      this.sendCodeEvent.emit(confirmationCode);
    }
    this.shouldCalculateError = confirmationCode.length === 6;
  }
}
